import { useRecoilState } from "recoil";
import { backendDataAtom } from "recoil/atoms/backendDataAtom.js";
import { useSnackbar } from "notistack";

export function useBookingExportActions() {
  const [backendData, setBackendData] = useRecoilState(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  // If backendData is already set for booking_exports, use it, otherwise default to empty
  const state =
    backendData?.type === "booking_exports"
      ? backendData
      : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "booking_exports",
      data: data,
    });
  };

  return {
    setState,
    state,
  };
}
